import PlayerBasicModel from "../../../Football/Models/Player/PlayerBasicModel";
import ResultModel from "../../../Predictor/Models/Fixtures/ResultModel";

export default class PredictionMatchQuizModel {
    public value: any = null;
    public target?: number = null;
    public playerId?: string = null;
    public playerModel?: PlayerBasicModel = null;
    public result: ResultModel = null;
}